exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#grillaDetalle[data-v-67ea9113] {\n  height: 400px !important;\n  scrollbar-width: 400px !important;\n  overflow: scroll;\n}\n", ""]);

// exports
